import { postRequest } from 'api';

export async function loginUser(dispatch, loginPayLoad) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        const params = new URLSearchParams();
        params.append('username', loginPayLoad.username);
        params.append('password', loginPayLoad.password);
        params.append('grant_type', loginPayLoad.grant_type);
        params.append('client_id', loginPayLoad.client_id);
        let response = await postRequest('/o/token/coach', params);
        const data = response.data;
        if (response.status === 200 && data.access_token) {
            dispatch({ type: "LOGIN_SUCCESS", payload: data });
            localStorage.setItem('Authentication', JSON.stringify(data));
        }
        return response;
    } catch (error) {
        dispatch({ type: "LOGIN_ERROR", error: error })
    }
}

export function logOut(dispatch) {
    dispatch({ type: 'LOGOUT' });
    localStorage.removeItem('Authentication');
}